import PropTypes from 'prop-types';
import { ReactComponent as CheckBoxIcon } from './checkbox.svg';
import { classNames } from '../utils';
import { isStableCoin } from 'services/currenciesConstant';

export const CheckBox = ({
  isActive,
  currency,
  networkCode,
  value,
  content,
  onChange,
  showCheckBox,
  className,
  disabled = false
}) => {
  const checkBoxClasses = classNames({
    'dropdown-choice': true,
    active: isActive,
    disabled: disabled,
    [className]: className
  });

  const handleCheckBox = () => {
    !disabled && onChange();
  };

  return (
    <div className={checkBoxClasses} role={'button'} tabIndex={0} onClick={handleCheckBox} onKeyDown={handleCheckBox}>
      {value && (
        <p className={currency ? 'dropdown-choice-value-with-currency' : 'dropdown-choice-value'}>
          {currency && !isStableCoin(currency) && <span className={'dropdown-choice-currency'}>{currency}</span>}
          {currency && isStableCoin(currency) && networkCode && (
            <span className={'dropdown-choice-currency'}>{`${currency} (${networkCode})`}</span>
          )}
          {value}
        </p>
      )}
      {content}
      {showCheckBox && <CheckBoxIcon className={'checkbox'} />}
    </div>
  );
};

CheckBox.propTypes = {
  isActive: PropTypes.bool.isRequired,
  value: PropTypes.string,
  currency: PropTypes.string,
  networkCode: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  showCheckBox: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool
};
